import { Injectable } from '@angular/core';
import { DatasourceService } from './datasource.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { Model_Datasource, AbsPaginatedGrid } from 'src/app/app.models';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

@Injectable()
export class DatasourceOfflineService extends DatasourceService {
    constructor(
        protected _httpClient: HttpClient,
        protected _apiService: ApiService,
        private _unitOfWork: UnitOfWorkOfflineDao,
    ) {
        super(_httpClient, _apiService);
    }
    
    doGetDatasourceByNum(_num: string) {
        return new Promise<Model_Datasource>(async (resolve, reject) => {
            const datasource = await this._unitOfWork.datasourcesDao.doGetDatasourceAction(_num);
            resolve(datasource);
        });
    }

    doBuildDatasourceByNumAction(_num: string) {
        return this._unitOfWork.datasourcesDao.doBuildDatasourceByNumAction(_num);
    }
}